import { useState } from "react";
import Cross from "../../assets/icons/Cross";
import DefaultButton from "../default-button/DefaultButton";
import ArrowLeft from "../../assets/icons/ArrowLeft";
import Tick from "../../assets/icons/Tick";
import InputField from "../input-field/InputField";

interface AddStudentModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (studentData: { email: string; className?: string }) => void;
}

export default function AddStudentModal({
    isOpen,
    onClose,
    onSubmit
}: AddStudentModalProps) {
    const [email, setEmail] = useState("");
    const [className, setClassName] = useState("");

    const handleSubmit = () => {
        if (email.trim()) {
            onSubmit({ email: email.trim(), className: className.trim() || undefined });
            handleClose();
        }
    };

    const handleClose = () => {
        setEmail("");
        setClassName("");
        onClose();
    };

    const validateForm = (): boolean => {
        return Boolean(email.trim());
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="w-fit p-8 rounded-xl bg-white text-black absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col">
                <div>
                    <div
                        onClick={handleClose}
                        className="flex justify-end cursor-pointer"
                    >
                        <Cross additionalStyle="text-[#5F6B88]" />
                    </div>
                    <p className="text-black font-normal text-[24px]">
                        Добавление студента
                    </p>
                </div>

                <div className="flex-grow mt-8 flex flex-col gap-4">
                    <div>
                        <p className="mb-2 font-medium text-[15px] text-[#5F6B88]">
                            E-mail студента
                        </p>
                        <InputField
                            type="text"
                            value={email}
                            handleChange={(e) => setEmail(e.target.value)}
                            placeholder="Введите e-mail студента"
                            additionalClassName="bg-[#F0F3FA] py-3 px-4 text-valley-black rounded-lg"
                        />
                    </div>
                    
                    <div>
                        <p className="mb-2 font-medium text-[15px] text-[#5F6B88]">
                            Класс (необязательно)
                        </p>
                        <InputField
                            type="text"
                            value={className}
                            handleChange={(e) => setClassName(e.target.value)}
                            placeholder="Введите класс"
                            additionalClassName="bg-[#F0F3FA] py-3 px-4 text-valley-black rounded-lg"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-[5fr_7fr] gap-3 mt-4">
                    <DefaultButton
                        buttonText="Вернуться"
                        additionalStyle="bg-[#5F6B88] text-white px-8 py-3 text-nowrap"
                        Icon={ArrowLeft}
                        onClick={handleClose}
                    />
                    <DefaultButton
                        buttonText="Добавить студента"
                        additionalStyle={`bg-valley-dark-green text-white px-8 py-3 text-nowrap ${
                            !validateForm() ? 'opacity-30' : ''
                        }`}
                        Icon={Tick}
                        onClick={handleSubmit}
                        disabled={!validateForm()}
                    />
                </div>
            </div>
        </div>
    );
}

